import * as z from "zod/v3";

export const Operation = z.object({
	key: z.string(),
	label: z.string(),
	permission: z.string(),
	href: z.string(),
	method: z.string(),
});
export type Operation = z.infer<typeof Operation>;

export const Operations = z.object({
	operations: z.array(Operation),
});
export type Operations = z.infer<typeof Operations>;

export const OperationItem = z
	.object({
		item: z.any().nullable().optional(),
	})
	.merge(Operations);

export type OperationItem<T> = {
	item: T | null | undefined;
} & Operations;
